export default {"src":"/_next/static/media/situation-health.364081e8.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};